module.exports = __webpack_public_path__ + "static/media/ReservationIconThumbnails.b520eef1.jpg";